import { render, staticRenderFns } from "./TableBuyerReady.vue?vue&type=template&id=0d2d45a1&"
import script from "./TableBuyerReady.vue?vue&type=script&lang=ts&"
export * from "./TableBuyerReady.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports